import React, { createContext, useContext, useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { StateChangedEvents } from '../../sdk/PlayerEvents';
import { Events, State } from '../../types/player';
import ControlButton from '../ui/ControlButton';

const Pip = () => {
  const { sdk } = usePlayerContext();

  const [pipState, setPipeState] = useState(false);

  useEffect(() => {
    sdk.on(Events.PIP_CHANGED, (isInPip: boolean) => {
      setPipeState(isInPip);
    });
  }, []);

  function toggle() {
    sdk.togglePip();
  }

  let browser = sdk.getUserAgent().getBrowser();

  if (browser === 'Firefox') return null;

  return (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control ${sdk.getClassNamePrefix()}-player-control-pip`}
    >
      <ControlButton
        className={'pip'}
        icon={'clone'}
        handleAction={toggle}
        title={'Picture in picture'}
      />
    </div>
  );
};

export default Pip;
